module.exports = __webpack_public_path__ + "media/src/assets/Images/ArrowBlue-61035a98f7b22b8e78613e5650528e57.svg";